import { react2panel } from 'common/util/react2panel';
import { SegmentLegendHeader } from './index';
export const SegmentLegendHeaderEl = react2panel("mp-segment-legend-header", SegmentLegendHeader, {
  contexts: ["segmentFilterController"]
});